import classNames from 'classnames';
import * as df from 'date-fns';
import { camelCase } from 'lodash-es';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import {
  Course,
  PaymentMethod,
} from '../../../interfaces/merchants/resources/books';
import BooksLabel from '../common/labels/BooksLabel';
import BooksMenuMerchant from './BooksMenuMerchant';

import css from './BooksMenuItemList.module.scss';

interface OwnProps {
  className?: string;
  nickname?: string;
  resourceName?: string;
  resourceId?: string;
  resourceImage?: string;
  resourceUrl?: string;
  payment?: PaymentMethod['method'];
  courseDate: string;
  courseTime: number | string;
  name: Course['name'];
  options: Course['options'];
  price?: string;
  staff?: string;
}

type Props = OwnProps & InjectedIntlProps;

const BooksMenuItemList = ({
  className,
  intl,
  payment,
  options,
  price,
  staff,
  ...props
}: Props) => {
  const classes = classNames(css.BooksMenuItemList, className);

  return (
    <div className={classes}>
      <BooksMenuMerchant
        image={props.resourceImage}
        name={props.resourceName}
        nickname={props.nickname}
        url={props.resourceUrl}
      />
      <dl className={css.BooksMenuItemList__List}>
        <dt className={css.BooksMenuItemList__ListTitle}>
          {intl.formatMessage({ id: 'books.booksMenu.choiceMenu' })}
        </dt>
        <dd className={css.BooksMenuItemList__ListData} data-style="name">
          {props.name}
          {options.map(option => (
            <span key={option.id} className={css.BooksMenuItemList__ListOption}>
              {option.name}
            </span>
          ))}
          {staff && (
            <span className={css.BooksMenuItemList__Staff}>
              {intl.formatMessage({ id: 'books.forms.staff' })}:
              <span className={css.BooksMenuItemList__StaffName}>{staff}</span>
            </span>
          )}
        </dd>
        {props.courseDate && (
          <>
            <dt className={css.BooksMenuItemList__ListTitle}>
              {intl.formatMessage({ id: 'books.booksMenu.bookDate' })}
            </dt>
            <dd className={css.BooksMenuItemList__ListData} data-style="date">
              <time className={css.BooksMenuItemList__ListDate}>
                {intl.formatDate(df.format(props.courseDate), {
                  month: 'narrow',
                  day: 'numeric',
                  weekday: 'short',
                })}
                <br />
                {props.courseTime}
              </time>
            </dd>
          </>
        )}
        {price && parseFloat(price) > 0 && (
          <>
            <dt className={css.BooksMenuItemList__ListTitle}>
              {intl.formatMessage({ id: 'books.booksMenu.totalPrice' })}
            </dt>
            <dd className={css.BooksMenuItemList__ListData} data-style="price">
              {price}円
            </dd>
            {payment && payment !== 'unspecified' && (
              <>
                <dt className={css.BooksMenuItemList__ListTitle}>
                  {intl.formatMessage({
                    id: 'books.booksMenu.paymentMethod',
                  })}
                </dt>
                <dd className={css.BooksMenuItemList__ListData}>
                  {payment === 'credit_card' && (
                    <span className={css.BooksMenuItemList__ListTag}>
                      <BooksLabel
                        label={intl.formatMessage({
                          id: 'books.paymentMethod.prepayment',
                        })}
                      />
                    </span>
                  )}
                  {intl.formatMessage({
                    id: `books.paymentMethod.${camelCase(payment)}`,
                  })}
                </dd>
              </>
            )}
          </>
        )}
      </dl>
    </div>
  );
};

export default injectIntl(BooksMenuItemList);
